import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-97b3a986"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fill-in-apply-wrap" }
const _hoisted_2 = { class: "fill-in-apply" }
const _hoisted_3 = { class: "receipt-info-wrap" }

import ItemInfo from './item-info.vue'
import {
  ref,
  watch,
  computed,
  withDefaults,
  watchEffect,
  onMounted,
  onActivated,
} from 'vue'
import ReasonTypeList from './reason-type-list.vue'
import PopCommonWrap from '@/components/popup/common-wrap.vue'
import type { ItemInfoProps } from './item-info.vue'
import { useRouter } from 'vue-router'
import { NameReissueAddressInfoStorage } from '@/storage/nameplate-reissue'
import type { AddressEditInfo } from 'vant'
import { getNameplateReissueApplyReason } from '@/apis/nameplate-reissue'
import type {
  NameplateReissueApplyReasonItem,
  FillInApplyInfoSetData,
} from '@/types/nameplate-reissue'
import type { CommonUploaderFileListItem } from '@/types/public'
import { useImageGuidTransfer } from '@/compositions/common'
import type { Ref } from 'vue'
import { NameReissueModifyAddressInfoStorage } from '@/storage/nameplate-reissue'

export default /*#__PURE__*/_defineComponent({
  __name: 'fill-in-apply-info',
  props: {
    isEdit: { type: Boolean },
    isCanNext: { type: Boolean },
    guid: { default: '' }
  },
  emits: ["update:isCanNext"],
  setup(__props: any, { expose, emit }: { emit: ({
  (event: 'update:isCanNext', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isEdit: boolean, isCanNext: boolean, guid: string };





let isCanNext = computed({
  get() {
    return props.isCanNext
  },
  set(value) {
    emit('update:isCanNext', value)
  },
})
const { getImageFullUrl } = useImageGuidTransfer()
const $router = useRouter()
let applyReasonActionShow = ref(false)
const refreshing = ref(false)
const currentReason = ref()
const pageReason = ref()
const cacheApplyReasonListData = ref<NameplateReissueApplyReasonItem>()
let infoArr = ref<Array<ItemInfoProps>>([
  {
    title: '申请原因',
    isRequired: true,
    isShowArrowRight: true,
    value: '',
    valueTip: '请选择申请原因',
    prop: 'applyReason',
    clickHandle,
  },
  {
    title: '原因说明',
    isRequired: true,
    uiType: 'field',
    prop: 'reason',
    value: '',
    valueTip: '请填写原因说明',
  },
  {
    title: '所在权证明说明',
    prop: 'owner',
    isRequired: false,
    value: '',
    uiType: 'field',
    valueTip: '请填写所在权证明说明',
    tip: '示例：XXX(购买人)在YYYY年MM月DD日在XXX（何处）购买的设备',
  },
  {
    title: '附图',
    value: [],
    prop: 'attachedPicture',
    isRequired: false,
    acceptValue: 'image/*',
    uiType: 'uploadImg',
  },
  {
    title: '上传附件',
    value: [],
    prop: 'uploadAttachment',
    isRequired: false,
    uiType: 'uploadImg',
    acceptValue: '*',
    isRequiredBottom: false,
  },
])
let reasonTypeListData = ref([])
let receiptInfo = ref({
  title: '收件信息',
  prop: 'receiptInfo',
  isRequired: true,
  isRequiredBottom: false,
  isShowArrowRight: true,
  value: [],
  valueTip: '请填写收件信息',
  clickHandle,
})

watchEffect(() => {
  let reasonItem = infoArr.value.find((_) => _.prop === 'reason')
  if (pageReason.value !== undefined && reasonItem.value !== '' && receiptInfo.value.value.length) {
    isCanNext.value = true
  } else {
    isCanNext.value = false
  }
})
function initReceiptInfo() {
  let data = props.guid
    ? (NameReissueModifyAddressInfoStorage.get() as AddressEditInfo)
    : (NameReissueAddressInfoStorage.get() as AddressEditInfo)
  if (data) {
    receiptInfo.value.value = [
      `${data.name} ${data.tel}`,
      `${[data.province, data.city, data.county, data.addressDetail].join('')}`,
    ]
  }
}

function clickHandle(item: ItemInfoProps) {
  console.log('clickHandle', item)
  switch (item.prop) {
    case 'applyReason':
      currentReason.value = pageReason.value
      applyReasonActionShow.value = true
      break
    case 'receiptInfo':
      if (props.guid) {
        $router.push({
          name: 'nameplate-edit-receipt-info',
          query: {
            isModify: 'yes',
          },
        })
      } else {
        $router.push({
          name: 'nameplate-edit-receipt-info',
        })
      }
      break
  }
}

function itemInfoValueChangeHandle(item: ItemInfoProps) {
  console.log('itemInfoValueChangeHandle', item)
  infoArr.value.find((_) => _.prop === item.prop).value = item.value
  if (item.prop === 'attachedPicture') {
    let attachedPictureItem = infoArr.value.find((_) => _.prop === 'attachedPicture')
    attachedPictureItem.imgags = (item.value as Array<CommonUploaderFileListItem>).map(
      (_) => _.response.guid
    )
  } else if (item.prop === 'uploadAttachment') {
    let attachedPictureItem = infoArr.value.find((_) => _.prop === 'uploadAttachment')
    attachedPictureItem.imgags = (item.value as Array<CommonUploaderFileListItem>).map(
      (_) => _.response.guid
    )
  }
}
watch(
  () => props.isEdit,
  (isEdit) => {
    let applyReasonItem = infoArr.value.find((_) => _.prop === 'applyReason')
    let reasonItem = infoArr.value.find((_) => _.prop === 'reason')
    let ownerItem = infoArr.value.find((_) => _.prop === 'owner')
    let attachedPictureItem = infoArr.value.find((_) => _.prop === 'attachedPicture')
    let uploadAttachmentItem = infoArr.value.find((_) => _.prop === 'uploadAttachment')
    infoArr.value = infoArr.value.map((_) => {
      return {
        ..._,
        isEdit,
      }
    })
    if (isEdit) {
      //填写申请说明
      applyReasonItem.isShowArrowRight = true
      applyReasonItem.clickHandle = clickHandle
      receiptInfo.value.isShowArrowRight = true
      receiptInfo.value.clickHandle = clickHandle
      reasonItem.uiType = 'field'
      ownerItem.uiType = 'field'
      delete attachedPictureItem.imgags
      delete uploadAttachmentItem.imgags
    } else {
      // 确认提交信息
      applyReasonItem.isShowArrowRight = false
      delete applyReasonItem.clickHandle
      receiptInfo.value.isShowArrowRight = false
      delete receiptInfo.value.clickHandle
      delete reasonItem.uiType
      delete ownerItem.uiType
      attachedPictureItem.imgags = []
      uploadAttachmentItem.imgags = []
    }
  },
  {
    immediate: true,
  }
)
const onRefresh = () => {
  getApplyReasonData()
}
getApplyReasonData()
async function getApplyReasonData() {
  try {
    refreshing.value = true
    let data = await getNameplateReissueApplyReason()
    cacheApplyReasonListData.value = data
    reasonTypeListData.value = Object.keys(data || {}).map((_: string) => {
      return {
        value: Number(_),
        label: data[_],
      }
    })
    refreshing.value = false
  } catch (e) {
    refreshing.value = false

    console.log(e)
  }
}

function reasonTypeConfrimHandle(value: number) {
  let resonTypeItem = infoArr.value.find((_) => _.prop === 'applyReason')
  pageReason.value = value
  resonTypeItem.value = cacheApplyReasonListData.value[value]
  applyReasonActionShow.value = false
}

function getParams() {
  let addressData
  if (props.guid) {
    addressData = NameReissueModifyAddressInfoStorage.get() as AddressEditInfo
  } else {
    addressData = NameReissueAddressInfoStorage.get() as AddressEditInfo
  }
  let params = {
    reason_type: pageReason.value as number,
    reason: infoArr.value.find((_) => _.prop === 'reason').value as string,
    description: infoArr.value.find((_) => _.prop === 'owner').value as string,
    images: infoArr.value.find((_) => _.prop === 'attachedPicture').imgags,
    files: infoArr.value.find((_) => _.prop === 'uploadAttachment').imgags,
    receive_express: {
      name: addressData.name,
      phone: addressData.tel,
      province: addressData.province,
      city: addressData.city,
      area: addressData.county,
      address: addressData.addressDetail,
      areaCode: addressData.areaCode,
    },
  }
  return params
}
const images = ref<Array<{ url: string }>>([])
const files = ref<Array<{ url: string }>>([])
async function initImageList(
  guid: Array<string>,
  imgList: Ref<
    Array<{
      url: string
    }>
  >
) {
  try {
    const data = await getImageFullUrl(guid)
    console.log('data', data)
    imgList.value = guid.map((guid) => ({
      url: data[guid].url,
    }))
  } catch (error) {
    console.log('error', error)
  }
}
onMounted(() => {
  initReceiptInfo()
})

onActivated(() => {
  initReceiptInfo()
})

async function setData(data: FillInApplyInfoSetData) {
  try {
    currentReason.value = data.currentReason
    pageReason.value = data.pageReason
    NameReissueModifyAddressInfoStorage.set(data.receiptInfo)
    initReceiptInfo()
    await initImageList(data.images, images)
    await initImageList(data.files, files)
    infoArr.value = infoArr.value.map((_) => {
      switch (_.prop) {
        case 'applyReason':
          _.value = data.reason_type_text
          break
        case 'reason':
          _.value = data.reason
          break
        case 'owner':
          _.value = data.description
          break
        case 'attachedPicture':
          _.imgags = data.images || []
          _.value = images.value.map((_) => _) || []
          break
        case 'uploadAttachment':
          _.imgags = data.files || []
          _.value = files.value.map((_) => _) || []
          break
      }
      return _
    })
  } catch (e) {
    console.log(e)
  }
}
expose({
  getParams,
  setData,
  applyReasonActionShow,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(infoArr), (item, index) => {
        return (_openBlock(), _createBlock(ItemInfo, _mergeProps(item, {
          key: index,
          onValueChange: itemInfoValueChangeHandle
        }), null, 16))
      }), 128))
    ]),
    _createVNode(PopCommonWrap, {
      show: _unref(applyReasonActionShow),
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (_isRef(applyReasonActionShow) ? (applyReasonActionShow).value = $event : applyReasonActionShow = $event)),
      "safe-area-inset-bottom": "",
      title: "申请原因",
      class: "pop-wrap",
      style: { minHeight: '60vh' }
    }, {
      default: _withCtx(() => [
        _createVNode(ReasonTypeList, {
          data: _unref(reasonTypeListData),
          refreshing: refreshing.value,
          "onUpdate:refreshing": _cache[0] || (_cache[0] = ($event: any) => ((refreshing).value = $event)),
          checked: currentReason.value,
          "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((currentReason).value = $event)),
          onOnRefresh: onRefresh,
          onConfirm: reasonTypeConfrimHandle
        }, null, 8, ["data", "refreshing", "checked"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(ItemInfo, _mergeProps(_unref(receiptInfo), { onValueChange: itemInfoValueChangeHandle }), null, 16)
    ])
  ]))
}
}

})